module.exports = __webpack_public_path__ + "img/smell-5.8533c62e.svg";